<template>
  <div
    id="summit-difference"
    class="bg-primary-140">
    <div
      v-if="testVariant ==='B'"
      class="grid grid-rows-2 md:grid-rows-1 grid-cols-2 md:grid-cols-6 gap-4 md:pr-10">
      <div class="flex items-center justify-center md:text-left col-span-2 md:col-span-1 relative bg-primary-140">
        <h3 class="font-bold text-white md:pl-10 z-20 leading-8">
          More CE Courses
        </h3>
        <div class="test-triangle-1 hidden md:block absolute top-0 -right-10 z-0" />
      </div>
      <div class="text-center py-4">
        <img
          src="//summitproedu.imgix.net/redesign-assets/icons/2025/ceus.svg"
          alt="In Person CE"
          class="h-12 mx-auto"
        />
        <h3 class="font-bold text-white">
          {{ newCoursesPerYear }}+
        </h3>
        <p class="text-accent-light font-bold text-xs">
          New Courses Annually
        </p>
      </div>
      <div class="text-center py-4">
        <img
          src="//summitproedu.imgix.net/redesign-assets/icons/2025/online_video.svg"
          alt="Online Video CE"
          class="h-12 mx-auto"
        />
        <h3 class="font-bold text-white">
          {{ onlineCourses }}+
        </h3>
        <p class="text-accent-light font-bold text-xs">
          On-Demand Courses
        </p>
      </div>
      <div class="text-center py-4">
        <img
          src="//summitproedu.imgix.net/redesign-assets/icons/2025/webinar.svg"
          alt="Webinars"
          class="h-12 mx-auto"
        />
        <h3 class="font-bold text-white">
          {{ liveWebinars }}+
        </h3>
        <p class="text-accent-light font-bold text-xs">
          Live Webinars Annually
        </p>
      </div>
      <div class="text-center py-4">
        <img
          src="//summitproedu.imgix.net/redesign-assets/icons/2025/live-stream.svg"
          alt="Star Rating"
          class="h-10 mx-auto mt-1 mb-1"
        />
        <h3 class="font-bold text-white">
          {{ liveStreams }}+
        </h3>
        <p class="text-accent-light font-bold text-xs">
          Live Streams Annually
        </p>
      </div>
      <div class="text-center py-4">
        <img
          src="//summitproedu.imgix.net/redesign-assets/icons/2025/in_person.svg"
          alt="In Person CE"
          class="h-12 mx-auto"
        />
        <h3 class="font-bold text-white">
          {{ inPersonCourses }}+
        </h3>
        <p class="text-accent-light font-bold text-xs">
          In-Person Courses Annually
        </p>
      </div>
    </div>
    <div
      v-else-if="testVariant ==='C'"
      class="grid grid-rows-2 md:grid-rows-1 grid-cols-2 md:grid-cols-7 gap-4 md:pr-10"
    >
      <div class="flex items-center justify-center md:text-left col-span-2 md:col-span-1 relative bg-primary-140">
        <h3 class="font-bold text-white md:pl-10 z-20">
          Better CE Courses
        </h3>
        <div class="test-triangle hidden md:block absolute top-0 -right-10 z-0" />
      </div>
      <div class="text-center py-4">
        <img
          src="//summitproedu.imgix.net/redesign-assets/icons/2025/star_rating.svg"
          alt="Star Rating"
          class="h-14 mx-auto"
        />
        <h3 class="font-bold text-white">
          4.7/5.0
        </h3>
        <p class="text-accent-light font-bold text-xs">
          Star Course Rating
        </p>
      </div>
      <div class="text-center py-4">
        <img
          src="//summitproedu.imgix.net/redesign-assets/icons/2025/quality.svg"
          alt="In Person CE"
          class="h-14 mx-auto"
        />
        <h3 class="font-bold text-white">
          {{ fiveStarReviews }},000+
        </h3>
        <p class="text-accent-light font-bold text-xs">
          5-Star Reviews
        </p>
      </div>
      <div class="text-center py-4">
        <img
          src="//summitproedu.imgix.net/redesign-assets/icons/2025/formats.svg"
          alt="Online Video CE"
          class="h-14 mx-auto"
        />
        <h3 class="font-bold text-white">
          {{ reportedNewSkillsLearned }}
        </h3>
        <p class="text-accent-light font-bold text-xs">
          Reported New Skills Learned
        </p>
      </div>
      <div class="text-center py-4">
        <img
          src="//summitproedu.imgix.net/redesign-assets/icons/2025/webinar.svg"
          alt="Webinars"
          class="h-14 mx-auto"
        />
        <h3 class="font-bold text-white">
          {{ instructorRating }}
        </h3>
        <p class="text-accent-light font-bold text-xs">
          Star Instructor Rating
        </p>
      </div>
      <div class="text-center py-4">
        <img
          src="//summitproedu.imgix.net/redesign-assets/icons/2025/improved_outcomes.svg"
          alt="In Person CE"
          class="h-14 mx-auto"
        />
        <h3 class="font-bold text-white">
          {{ percentLongFormat }}
        </h3>
        <p class="text-accent-light font-bold text-xs pl-4 mb-6 md:pl-0 md:mb-0">
          of Courses are Long-Format <br /> (2-6 hours)
        </p>
      </div>
      <div class="text-center py-4">
        <img
          src="//summitproedu.imgix.net/redesign-assets/icons/2025/ceus.svg"
          alt="In Person CE"
          class="h-14 mx-auto"
        />
        <h3 class="font-bold text-white">
          {{ customerServiceSatisfaction }}
        </h3>
        <p class="text-accent-light font-bold text-xs">
          Customer Service Satisfaction
        </p>
      </div>
    </div>
    <div
      v-else
      class="grid grid-rows-2 md:grid-rows-1 grid-cols-2 md:grid-cols-7 gap-4 md:pr-10"
    >
      <div class="flex items-center justify-center md:text-left col-span-2 md:col-span-1 relative bg-primary-140">
        <h3 class="font-bold text-white md:pl-10 z-20">
          The Summit Difference
        </h3>
        <div class="triangle hidden md:block absolute top-0 -right-10 z-0" />
      </div>
      <div class="text-center py-4">
        <img
          src="//summitproedu.imgix.net/redesign-assets/icons/2025/in_person.svg"
          alt="In Person CE"
          class="h-14 mx-auto"
        />
        <h3 class="font-bold text-white">
          {{ inPersonCourses }} +
        </h3>
        <p class="text-accent-light font-bold text-xs">
          In-Person Courses Annually
        </p>
      </div>
      <div class="text-center py-4">
        <img
          src="//summitproedu.imgix.net/redesign-assets/icons/2025/online_video.svg"
          alt="Online Video CE"
          class="h-14 mx-auto"
        />
        <h3 class="font-bold text-white">
          {{ onlineCourses }}+
        </h3>
        <p class="text-accent-light font-bold text-xs">
          Online Courses
        </p>
      </div>
      <div class="text-center py-4">
        <img
          src="//summitproedu.imgix.net/redesign-assets/icons/2025/webinar.svg"
          alt="Webinars"
          class="h-14 mx-auto"
        />
        <h3 class="font-bold text-white">
          {{ liveWebinars }}+
        </h3>
        <p class="text-accent-light font-bold text-xs">
          Live Webinars Annually
        </p>
      </div>
      <div class="text-center py-4">
        <img
          src="//summitproedu.imgix.net/redesign-assets/icons/2025/star_rating.svg"
          alt="Star Rating"
          class="h-14 mx-auto"
        />
        <h3 class="font-bold text-white">
          4.7/5.0
        </h3>
        <p class="text-accent-light font-bold text-xs">
          Star Rating<br /> ({{ fiveStarReviews }},000+ 5 Star Reviews)
        </p>
      </div>
      <div class="text-center py-4">
        <img
          src="//summitproedu.imgix.net/redesign-assets/icons/2025/improved_outcomes.svg"
          alt="In Person CE"
          class="h-14 mx-auto"
        />
        <h3 class="font-bold text-white">
          86%
        </h3>
        <p class="text-accent-light font-bold text-xs pl-4 mb-6 md:pl-0 md:mb-0">
          of Therapists Reported Improved Patient Outcomes
        </p>
      </div>
      <div class="text-center py-4">
        <img
          src="//summitproedu.imgix.net/redesign-assets/icons/2025/ceus.svg"
          alt="In Person CE"
          class="h-14 mx-auto"
        />
        <h3 class="font-bold text-white">
          {{ ceuDelivered }},000,000+
        </h3>
        <p class="text-accent-light font-bold text-xs">
          CEUs Delivered
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, } from 'pinia';
import { useMetricStore, } from '../../stores/metrics';

export default {
  name: 'SummitDifference',
  props: {
    testVariant: {
      type: String,
      default: 'B',
    },
  },
  computed: {
    ...mapState(useMetricStore, [
      'newCoursesPerYear',
      'onlineCourses',
      'liveWebinars',
      'liveStreams',
      'inPersonCourses',
      'fiveStarReviews',
      'reportedNewSkillsLearned',
      'instructorRating',
      'percentLongFormat',
      'customerServiceSatisfaction',
    ]),
  },
};
</script>

<style scoped>
.triangle {
  width: 0;
  height: 0;
  border-top: 80px solid transparent;
  border-left: 40px solid #233b55;
  border-bottom: 80px solid transparent;
  z-index: 1;
}

/* the divs for the triangles are different heights, so just made two */

.test-triangle-1 {
  width: 0;
  height: 0;
  border-top: 70px solid transparent;
  border-left: 40px solid #233b55;
  border-bottom: 65px solid transparent;
  z-index: 1;
}

.test-triangle {
  width: 0;
  height: 0;
  border-top: 80px solid transparent;
  border-left: 40px solid #233b55;
  border-bottom: 65px solid transparent;
  z-index: 1;
}
</style>
